import { gql } from '@apollo/client';

export const GET_LOCAL_STATE = gql`
  query GetLocalState {
    user @client
    menu @client
    exp @client
  }
`;
